import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const img = `
<svg xmlns="http://www.w3.org/2000/svg" width="22.943" height="18.908" viewBox="0 0 22.943 18.908">
  <g id="Group_2844" data-name="Group 2844" transform="translate(-260 -692.046)">
    <line id="Line_247" data-name="Line 247" x2="18.585" transform="translate(261.5 701.168)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/>
    <path id="Path_1739" data-name="Path 1739" d="M-18528-123l7,8.5-7,8.5" transform="translate(18801.996 816)" fill="none" stroke="#fff" stroke-width="3"/>
  </g>
</svg>

`

const RightArrowSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: img }} />
}

export default RightArrowSvg
